<ul class="divide-y divide-gray-200">
    <li
        class="py-8 first:pt-0"
        *ngFor="
            let review of reviews
                | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems }
        "
    >
        <div class="flex items-baseline space-x-2">
            <kb-star-rating [rating]="review.rating"></kb-star-rating>
            <h6 class="font-medium flex-1">{{ review.summary | uppercaseFirst }}</h6>
        </div>

        <blockquote class="mt-4">
            <p class="mb-0" [innerHTML]="review.body | nl2br"></p>
            <footer class="italic text-sm mt-2 text-gray-600">
                - {{ review.authorName }} from {{ review.authorLocation }} on
                {{ review.createdAt | date: 'mediumDate' }}
            </footer>
        </blockquote>
        <div class="text-gray-600" *ngIf="review.response">
            <em>Bromleys Art Supplies responded:</em>
            <p>{{ review.response }}</p>
        </div>
        <div class="text-sm text-gray-600 mt-6">
            <div class="flex">
                <span *ngIf="0 < review.upvotes || 0 < review.downvotes; else noVotesYet">
                    {{ review.upvotes }} of {{ review.upvotes + review.downvotes }} people found this review
                    helpful.
                    <span *ngIf="!hasVotedOnReview(review.id)">Did you?</span>
                </span>
                <ng-template #noVotesYet>
                    <span *ngIf="!hasVotedOnReview(review.id)">Did you find this review useful?</span>
                </ng-template>
                <div class="leading-3 ml-2" *ngIf="!hasVotedOnReview(review.id)">
                    <button
                        class="p-1 border border-gray-300 hover:bg-gray-100 rounded mr-2"
                        (click)="upvote(review.id)"
                    >
                        Yes
                    </button>
                    <button
                        class="p-1 border border-gray-300 hover:bg-gray-100 rounded"
                        (click)="downvote(review.id)"
                    >
                        No
                    </button>
                </div>
            </div>
            <div class="vote-feedback" *ngIf="hasJustVotedOn(review.id)">
                <fa-icon [icon]="check"></fa-icon>
                Thanks for your feedback!
            </div>
        </div>
    </li>
</ul>
<div class="controls" *ngIf="itemsPerPage">
    <kb-pagination (pageChange)="pageChange.emit($event)"></kb-pagination>
</div>
